import RichText from '@eneco/components/RichText/RichText';
import { AdvanceAmountChangedCardResponse } from '@eneco/dc-be/client/types.gen';
import { useFormatter } from '@eneco/i18n';
import { Stack, Text } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';

export const AdvanceAmountChangedCard = ({ card }: { card: AdvanceAmountChangedCardResponse }) => {
  const { format, currency } = useFormatter();
  const { fields } = useContent<DashboardOverviewRendering>();
  const newAdvanceAmount = card?.details?.advances?.totals?.currentAmount;

  return (
    <StyledDashboardBlock>
      <Stack gap="4" direction="row" alignY={'center'}>
        <Text>
          <RichText
            html={format(fields.advanceAmountChangedCard?.description?.value, {
              amount: currency.euro(newAdvanceAmount || 0),
            })}
          />
        </Text>
      </Stack>
      <DashboardLink
        href={fields.advanceAmountChangedCard?.link?.value?.href}
        emphasis="high"
        trackingComponentName="advance_amount_changed_link"
        trackingComponentType="dashboard_link">
        {fields.advanceAmountChangedCard?.link?.value?.text}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
